import { LDContext } from "launchdarkly-react-client-sdk";

declare global {
  interface Window {
    Cypress?: unknown;
  }
}

export type AnonymousContext = { anonymous: true; key?: string };

export interface Context {
  user:
    | { key: string; name?: string; email?: string; avatar?: string }
    | AnonymousContext;
  organisation: { key: string; name?: string } | AnonymousContext;
}

export type ContextKey = keyof Context;

export const ANONYMOUS_CONTEXT: AnonymousContext = {
  anonymous: true,
  key: window.Cypress ? "cypress" : undefined,
};

export const INITIAL_CONTEXT: LDContext = {
  kind: "multi",
  user: ANONYMOUS_CONTEXT,
};
